import { GameObj } from 'kaplay'
import k from '../constants/k'
import { w, h } from '../state/globals'
import { addHoverEffect } from './mouse'

k.loadSprite('book', 'sprites/ui/book.png')
let lastScene: string | null = null

export default (cursor: GameObj) => {
  const book = k.add([
    k.sprite('book'),
    k.pos(w - 15, h - 20),
    k.anchor('center'),
    k.area(),
    k.z(8)
  ])
  addHoverEffect(book, cursor)

  book.onClick(() => {
    k.play('pop')
    const currentScene = k.getSceneName()

    if (currentScene === 'bookMenu') {
      const dest = lastScene
      lastScene = null
      k.go(dest)
    } else {
      lastScene = currentScene
      k.go('bookMenu')
    }
  })

  book.onKeyDown('escape', () => {
    if (lastScene) {
      const dest = lastScene
      lastScene = null
      k.go(dest)
    }
  })
}
